<div
  class="activity-block"
  role="button"
  tabindex="0"
  [class.activity-block--active]="active()"
  [style.--block-color]="item().color"
  [attr.aria-label]="item().value + ' · ' + item().label"
  (click)="emitClick($event)"
  (keydown.enter)="emitClick($event)"
  (keydown.space)="emitClick($event)">
  <span class="activity-block__value">{{ item().value }}</span>
  <span class="activity-block__label">{{ item().label }}</span>
  <span class="activity-block__hint" aria-hidden="true">{{ shortDate() }}</span>
</div>
